<template>
    <div class="col-sm-6 mb-30" data-match-height="confirm">
        <div class="metro-box-wrapper equal-height">
            <div class="heading">
                <h3>Billing Information</h3>
            </div>
            <div class="content">
                <ul class="confirm-list">
                    <li><span class="absolute font600">Nombre:</span>Victor</li>
                    <li><span class="absolute font600">Apellidos:</span>Giró Marques</li>
                    <li><span class="absolute font600">Email: </span>victor@vola.cat</li>
                    <li><span class="absolute font600">Direccion: </span>Av.Exercit 33 4-9</li>
                    <li><span class="absolute font600">Código Postal:</span>25194</li>
                    <li><span class="absolute font600">Ciudad:</span>Lleida</li>
                    <li><span class="absolute font600">Teléfono: </span> +34 973 87 00 00</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "billingInformation"
    }
</script>

<style scoped>

</style>